import React, { useEffect, useRef } from 'react';
import BaseButton from '../Button/BaseButton';
import { useT } from '../../i18n/LanguageContext';

function KoreanSkillsList({ isMyPagePersonalInfo, selectedOption, onSelect }) {
  const t = useT();
  const options = [
    'Beginner',
    'Intermediate',
    'Advanced',
    'Native',
    'TOPIK certified',
    'TOPIK Speaking certified',
  ];

  const listRef = useRef(null);
  const selectedRef = useRef(null);

  useEffect(() => {
    if (listRef.current && selectedRef.current) {
      listRef.current.scrollTop = selectedRef.current.offsetTop - 8;
    }
  }, [selectedOption]);

  return (
    <div
      ref={listRef}
      className={`w-full min-w-[334px] bg-grayscale-gray00 border border-grayscale-gray02 
                rounded-[15px] p-2 shadow-popup-02 tabletH:min-w-[380px] ${isMyPagePersonalInfo && 'h-[206px] overflow-y-auto'}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ul role='menu' className='list-none p-0 m-0'>
        {options.map((option) => {
          const isSelected = option === selectedOption;

          return (
            <li
              key={option}
              ref={isSelected ? selectedRef : null}
              className='flex items-center rounded-lg transition-colors duration-150'
            >
              <BaseButton
                type='text'
                size='m'
                hideIcon
                bgclass='bg-grayscale-gray00'
                borderclass='border-none'
                textclass='justify-start'
                hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
                activeclass='active:bg-grayscale-gray02 active:text-text-primary'
                width='100%'
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(option);
                }}
                leftalign='true'
              >
                {t(
                  option,
                  {
                    Beginner: '초급',
                    Intermediate: '중급',
                    Advanced: '고급',
                    Native: '원어민',
                    'TOPIK certified': 'TOPIK 인증',
                    'TOPIK Speaking certified': 'TOPIK 말하기 인증',
                  }[option],
                )}
              </BaseButton>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default KoreanSkillsList;
